export function loadExternalLibraries() {
  loadGoogleAnalytics();
  loadWistia();
}

function loadGoogleAnalytics() {
  if (process.env.NODE_ENV !== "production") {
    return;
  }

  const script1 = window.document.createElement("script");
  script1.innerHTML = `
    window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date;
    ga('create', 'UA-48321784-1', 'auto');
    ga('send', 'pageview');
  `;

  const script2 = window.document.createElement("script");
  script2.setAttribute("src", "https://www.google-analytics.com/analytics.js");
  script2.async = true;

  window.document.head.appendChild(script1);
  window.document.head.appendChild(script2);
}

function loadWistia() {
  const script = window.document.createElement("script");
  script.setAttribute("src", "https://fast.wistia.com/assets/external/E-v1.js");
  window.document.head.appendChild(script);
}
